module.exports = {
cuurent_domain: "https://app.viewzzz.com",

// foursquare credentials
fs_client_id: 'NRLCPVL0ZVF4IOHFOH2YF54NSI0XQXR3B5K1FBII3VAPQ3MZ',
fs_client_secret: 'PGOSMOSDMGUWPGX4C5F53QATPEXDPC3QCEPEA5H01X0YICFV',
fs_redirectUrl: 'https://app.viewzzz.com/?loc=Worldwide',
fs_version: '20200728',

// firebase development
// apiKey: "AIzaSyCAuUeTdGQXpiV_2xru-pX4460Er0yK-Do",
// authDomain: "dev-wav.firebaseapp.com",
// databaseURL: "https://dev-wav.firebaseio.com",
// projectId: "dev-wav",
// storageBucket: "dev-wav.appspot.com",
// messagingSenderId: "170508625596",
// storageBucket:'dev-wav.appspot.com',

// firebase production
apiKey: "AIzaSyAOv2-dENsFi4tjhgMnr_pWFViDZ9fIxnY",
authDomain: "app.withaview.co",
databaseURL: "https://prod-eu-wav.firebaseio.com",
projectId: "prod-eu-wav",
storageBucket: "prod-eu-wav.appspot.com",
messagingSenderId: "615026429269",
appId: "1:615026429269:web:abb4aaec25e891ad0ab3dc",
measurementId: "G-M8G98775ZW",

// cloudinary developement
// cloudinary_cloudName: 'dayeblttk',
// cloudinary_apiKey: '616728461466718',
// cloudinary_apiSecret: 'RYMOwH4OAk0e7AEAh12xxMysweM',
// cloudinary_preset:'v1596539510',
// cloudinary_settings:'f_auto,fl_lossy,q_auto,dpr_auto,e_improve',

//cloudinary production
cloudinary_cloudName: 'xviewzzzx',
cloudinary_apiKey: '194857481468858',
cloudinary_apiSecret: 'LkdKocQmShIEArwY3VGlfMU2VZE',
cloudinary_preset:'v1540590871',
cloudinary_settings:'f_auto,fl_lossy,q_auto,dpr_auto,e_improve',

// imagga
imagga_apiKey: 'acc_7fdfd505c280e6a',
imagga_apiSecret: '7c93985c839156d62fdb2962c8c664e2',

//elastic search production
elasticSearch_url: 'http://35.234.105.166//elasticsearch/',
elasticSearch_username: 'user',
elasticSearch_password: 'dow17wJaxSiG',

// elasticSearch development
// elasticSearch_url: 'http://104.155.44.142//elasticsearch/',
// elasticSearch_username: 'user',
// elasticSearch_password: 'dow17wJaxSiG',

//flickr auth string
flickr_authString: '2d1f30e315009f177afe67162a2211b7',

//google APIs
googleVision_apiKey: 'AIzaSyCDm0m7yKThLUaBvYwM2sGCb-7zsX2n79I'

};


//////////////////
// WEBPACK FOOTER
// ./functions/configurations.js
// module id = 233
// module chunks = 17